import styled from "styled-components";
import { Button as ButtonPrimitive } from "../primitives/Button";
import { sizes } from "../theme";

// Exports
export interface PlainButtonProps {
  iconSize?: string;
}
export const PlainButton = styled(ButtonPrimitive)<PlainButtonProps>`
  > svg {
    width: ${props => props.iconSize || sizes.iconDefault};
  }
`;
